import { createSlice } from "@reduxjs/toolkit";
import { checkFilterSelection } from "utils/consumerFilterUtils";

const initialState = {
    filters: [],
    currentSelectedFilters: {},
    currentSelectedAllFilters: {},
    filterSelectionStatus: false,
    isLoading: true,
    missingFilters: {},
    isFilterAcrossProducts: false,
};

export const consumerFilterStore = createSlice({
    name: "consumerFilterStore",
    initialState,
    reducers: {
        loadFiltersState: (state, action) => {
            state.filters = action.payload;
        },
        loadCurrentSelectedFiltersState: (state, action) => {
            state.currentSelectedFilters = action.payload;
            state.filterSelectionStatus = checkFilterSelection(action.payload);
        },
        loadCurrentSelectedAllFiltersState: (state, action) => {
            state.currentSelectedAllFilters = action.payload;
        },
        loadIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        // Add the reset action here
        resetConsumerFilterStoreState: () => initialState,

        loadMissingFiltersState: (state, action) => {
            state.missingFilters = action.payload;
        },
        loadIsFilterAcrossProductsState: (state, action) => {
            state.isFilterAcrossProducts = action.payload;
        },
    },
});

export const { loadFiltersState, loadCurrentSelectedFiltersState, loadCurrentSelectedAllFiltersState, loadIsLoading, resetConsumerFilterStoreState, loadMissingFiltersState, loadIsFilterAcrossProductsState } = consumerFilterStore.actions;

export default consumerFilterStore.reducer;
